import { TrustPilotStar } from '@/components/Icons/TrustPilotStar';
import Box from '@mui/material/Box';

function Star({ fill = 0 }) {
	return (
		<Box
			sx={{
				position: 'relative',
				width: 20,
				height: 20,
				overflow: 'hidden',
				bgcolor: '#DCDCE6'
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					left: 0,
					top: 0,
					width: `${fill * 100}%`,
					height: '100%',
					bgcolor: '#00B67A'
				}}
			/>

			<Box
				sx={{
					position: 'absolute',
					inset: 0,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}}
			>
				<TrustPilotStar
					style={{
						width: 12,
						height: 12,
						color: '#fff'
					}}
				/>
			</Box>
		</Box>
	);
}

function Rating({ value = 4.5, max = 5, sx }) {
	return (
		<Box
			sx={{
				display: 'flex',
				gap: '1.5px',
				...sx
			}}
		>
			{Array.from({ length: max }).map((_, i) => {
				const diff = value - i;

				let fill = 0;

				if (diff >= 1) {
					fill = 1;
				} else if (diff >= 0) {
					fill = 0.5;
				}

				return <Star key={i} fill={fill} />;
			})}
		</Box>
	);
}

export default Rating;
